<template>
  <div
    class="filterControls"
    ref="filterControls"
  >
    <div
      v-for="filter in [selectedTopic, selectedLocation, selectedTradeType, selectedScale]"
      v-if="filter"
      :key="filter.id"
      :class="['filterControlsItem', 'filterControlsItem--' + filter.type]"
      :content="getTooltipContent(filter)"
      v-tippy="{ theme: 'statzon', placement: 'top', arrow: true, animation: 'scale' }"
      @click="createRipple($event); search(filter)"
    >
      <div
        :class="['filterControlsItem__icon', 'filterControlsItem__icon--' + filter.type]"
        v-html="getFilterIcon(filter.type)"
      />
      <div
        :class="['filterControlsItem__name', 'filterControlsItem__name--' + type, 'filterControlsItem__name--' + filter.type]"
        v-html="filter.attributes.name"
      />
    </div>
  </div>
</template>

<script>
import configFile from '@/helpers/config.js'
import helperMethods from '@/helpers/utility.js'

export default {
  props: {
    selectedTopic: {
      type: [Object, Boolean],
      default: function () {
        return false
      }
    },
    selectedLocation: {
      type: [Object, Boolean],
      default: function () {
        return false
      }
    },
    selectedTradeType: {
      type: [Object, Boolean],
      default: function () {
        return false
      }
    },
    selectedScale: {
      type: [Object, Boolean],
      default: function () {
        return false
      }
    },
    type: {
      type: String,
      default: 'dataset'
    }
  },
  data () {
    return {
      config: configFile,
      windowWidth: window.innerWidth,
      visible: false
    }
  },
  computed: {
    selectedFilters () {
      return this.$store.getters['search/getSelectedFilters']
    }
  },
  methods: {
    search (filter) {
      if (filter.id) {
        this.$router.push('/' + this.type + 's?' + filter.type + '=' + filter.id + '&page=1&sort=-published')
      }

      return false
    },
    getTooltipContent (filter) {
      if (filter.id) {
        return 'Search all <i>' + this.getTypeName(this.type + 's').toLowerCase() + '</i> with "<u>' + filter.attributes.name + '</u>" <i>' + this.getFilterName(filter.type).toLowerCase() + '</i>'
      }

      return ''
    },
    calculateFilterWidths () {
      document.getElementsByClassName('filterControlsItem--topics')[0] ? document.getElementsByClassName('filterControlsItem--topics')[0].style = 'max-width: auto' : false
      document.getElementsByClassName('filterControlsItem--locations')[0] ? document.getElementsByClassName('filterControlsItem--locations')[0].style = 'max-width: auto' : false
      document.getElementsByClassName('filterControlsItem--trade_types')[0] ? document.getElementsByClassName('filterControlsItem--trade_types')[0].style = 'max-width: auto' : false
      document.getElementsByClassName('filterControlsItem--scales')[0] ? document.getElementsByClassName('filterControlsItem--scales')[0].style = 'max-width: auto' : false

      let filtersWidth = this.$refs.filterControls ? this.$refs.filterControls.offsetWidth : 0
      let controlsWidth = this.type === 'dataset' ? (document.getElementById('dataset__chartControls') ? Math.ceil(document.getElementById('dataset__chartControls').offsetWidth) : 0) : 0
      let maxWidth = document.getElementById(this.type + '__controls') ? Math.floor(document.getElementById(this.type + '__controls').offsetWidth - (this.type === 'dataset' ? 32 : 16)) : 0
      let requiredWidth = Math.ceil(filtersWidth + controlsWidth)

      if (requiredWidth > maxWidth) {
        let filters = {
          'topics': document.getElementsByClassName('filterControlsItem--topics')[0] ? document.getElementsByClassName('filterControlsItem--topics')[0].offsetWidth : 0,
          'locations': document.getElementsByClassName('filterControlsItem--locations')[0] ? document.getElementsByClassName('filterControlsItem--locations')[0].offsetWidth : 0,
          'trade_types': document.getElementsByClassName('filterControlsItem--trade_types')[0] ? document.getElementsByClassName('filterControlsItem--trade_types')[0].offsetWidth : 0,
          'scales': document.getElementsByClassName('filterControlsItem--scales')[0] ? document.getElementsByClassName('filterControlsItem--scales')[0].offsetWidth : 0
        }

        let sorted = Object.keys(filters).sort(function(a, b) { return filters[b]-filters[a] })
        let percentages = {}
        let addition = 0

        sorted.forEach(el => {
          let filterElement = document.getElementsByClassName('filterControlsItem--' + el)[0] ? document.getElementsByClassName('filterControlsItem--' + el)[0] : false

          if (filterElement) {
            let percentage = filterElement.scrollWidth / filtersWidth

            if (maxWidth < 640 || percentage >= 0.15) {
              percentages[el] = percentage
            } else {
              addition += percentage
            }
          }
        })

        Object.entries(percentages).forEach(el => {
          let filterElement = document.getElementsByClassName('filterControlsItem--' + el[0])[0] ? document.getElementsByClassName('filterControlsItem--' + el[0])[0] : false

          if (filterElement) {
            let padding = addition / Object.keys(percentages).length
            let newWidth = Math.floor(filterElement.scrollWidth - ((requiredWidth - maxWidth) * (el[1] + padding)) - 16)
            if (newWidth < 1) {
              newWidth = 0
            }

            filterElement.style = 'max-width: ' + newWidth + 'px'
          }
        })
      }
    },
    resize () {
      this.windowWidth = window.innerWidth
      this.calculateFilterWidths()
    },
    ...helperMethods
  },
  created () {
    window.addEventListener('resize', this.resize)
  },
  unmounted () {
    window.removeEventListener('resize', this.resize)
  },
  mounted () {
    this.resize()
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.filterControls {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  position: relative;
  top: -1px;
  border-left: 1px solid $black;
  border-right: 1px solid rgba($white, 0.1);
  margin: 0 0.5rem;
  height: 37px;
  background-color: $bg-4;

  @media screen and (min-width: $breakpointLg) {
    height: 41px;
  }

  &Item {
    display: flex;
    align-items: center;
    position: relative;
    overflow: hidden;
    height: 36px;
    width: auto;
    min-width: 22px;
    max-width: auto;
    border-left: 1px solid rgba($white, 0.1);
    border-right: 1px solid $black;
    border-top: 1px solid rgba($white, 0.1);
    padding: 0 8px;
    cursor: pointer;
    user-select: none;

    @media screen and (min-width: $breakpointLg) {
      height: 40px;
      padding: 0 10px;
    }

    &:hover {
      background-color: $bg-1;

      .filterControlsItem__icon {
        transform: scale(1.2);

        @media screen and (min-width: $breakpointLg) {
          transform: scale(1.175);
        }

        &--topics {
          fill: rgba($blue, 0.9) !important;
        }

        &--locations {
          fill: rgba($green, 0.9) !important;
        }

        &--trade_types {
          fill: rgba($yellow, 0.67) !important;
        }

        &--scales {
          fill: rgba($orange, 0.9) !important;
        }
      }

      .filterControlsItem__name {
        &--topics {
          color: $blue !important;
        }

        &--locations {
          color: $green !important;
        }

        &--trade_types {
          color: $yellow !important;
        }

        &--scales {
          color: $orange !important;
        }
      }
    }

    &__name {
      display: block;
      margin: 0 0.5rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      transition: color 0.2s ease-out;

      &--dataset {
        display: none;

        @media screen and (min-width: $breakpointSm) {
          display: block;
        }
      }
    }

    &__icon {
      display: flex;
      min-width: 20px;
      width: 20px;
      height: 20px;
      fill: rgba($white, 0.7);
      transform: scale(1);
      transition: fill 0.2s ease-out, transform 0.2s ease-out;

      @media screen and (min-width: $breakpointLg) {
        min-width: 22px;
        width: 22px;
        height: 22px;
      }
    }
  }
}

</style>
